import { SignIn } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import Row from '../Row';
import Section from '../Section';
import Explanation from './Explanation';

const Container = ContainerDefault.extend`
    max-width: 20rem;
    position: relative;
`;

const help = {
    signIn: {
        head: 'You have no login?',
        text:
            'If you are new to V-Sponse and just got an invitation by email, you have to create a new account by clicking on "Sign Up".'
    },
    signedUp: {
        head: 'You successfully signed up!',
        text: 'Please sign in to work with V-Sponse.'
    },
    signedOut: { head: 'You successfully signed out', text: '' }
};

export default class CustomSignIn extends SignIn {
    public render() {
        const { authState } = this.props;

        if (!['signIn', 'signedOut', 'signedUp'].includes(authState)) {
            return null;
        }
        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Sign In</h3>
                        <input placeholder="Email" key="username" name="username" onChange={this.handleInputChange} />
                        <input
                            placeholder="Password"
                            type="password"
                            key="password"
                            name="password"
                            onChange={this.handleInputChange}
                        />
                        <Button onClick={this.signIn}>Sign In</Button>
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('forgotPassword', undefined)}>
                            Forgot Password
                        </Button>
                        <Button normal onClick={() => this.changeState('signUp', undefined)}>
                            Sign Up
                        </Button>
                    </Row>
                    <Explanation help={help[authState]} />
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomSignIn.tsx